import {NullNotificationAdapter} from '@vizir-banking/banking-app-core/dist/notification/adapters/null-notification-adapter';

export const notificationAdapter = new NullNotificationAdapter();
